import api from '../../utils/services/api';

import {
  digitalServicesActionError,
  digitalServicesActionLoading,
  digitalServicesActionSuccess,
} from '../ducks/digitalServices';

export const digitalServicesFetchAction = ({
  limit = '10',
  search = '',
  page = 1,
  dataInicial = '',
  dataFinal = '',
  status = '0',
}) => {
  return async (dispatch) => {
    dispatch(digitalServicesActionLoading());
    try {
      const response = await api.get(
        `servicos_digitais/listar/transacoes?DATA_INICIO=${dataInicial}&DATA_FIM=${dataFinal}&PAGE=${page}&LIMIT=${limit}&STATUS=${status}&SEARCH=${search}`,
      );
      dispatch(digitalServicesActionSuccess(response.data));
    } catch (error) {
      dispatch(digitalServicesActionError(error?.response?.data));
    }
  };
};
